export default __webpack_public_path__ + "static/media/gd.e8fc3c32.svg";